<div class="app-chat">

    <div class="chat-container" [class.active]='openChatList'>
        <div class="chat-head" (click)="openChatList = !openChatList">
            <img src="./assets/images/icons/ic_chat.svg" alt="">
            {{ 'chat.Chat with Members' | translate }}
        </div>

        <div class="users-list">
            <div class="search">
                <div>
                    <button class="btn" (click)="getUsers(searchText)">
                        <img src="./assets/images/icons/search-btn.svg" alt="">
                    </button>
                    <input type="text" placeholder="{{ 'chat.Search' | translate }}" [(ngModel)]='searchText' (keydown.enter)="getUsers(searchText)">
                </div>
            </div>

            <div class="scroll-area" *ngIf='loadingUsers'>
                <div class="dataLoading">
                    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                </div>
            </div>
            <ul class="scroll-area" *ngIf='!loadingUsers'>
              <div class="nodata nochat" *ngIf="!usersList.length">
                {{ 'group.NoDataFound' | translate }}
              </div>
              <li *ngFor="let user of usersList" (click)='openChat(user)'>
                    <div class="name-with-image mb-3 mb-sm-0"
                        *ngIf="!user.creatorId">
                        <div class="image-circle">
                            <img *ngIf="user.profilePicture"
                                    [src]="user.profilePicture"
                                    (error)="user.profilePicture = ''" />
                            <span
                                *ngIf="!user.profilePicture">{{ user.name | shortName }}</span>
                        </div>
                        <div class="name">
                            <h5>{{user.userEnglishName}}</h5>
                            <h6>{{user.userArabicName}}</h6>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="chat-rooms">
        <div class="chat-container room"
            (click)="chatSeen(chat.user.id)"
            [class.active]='chat.active' *ngFor="let chat of activeChats; index as i">
            <div class="chat-head" (click)='chat.active = !chat.active'>
                <div class="name-with-image mb-3 mb-sm-0"
                    *ngIf="!chat.user.creatorId">
                    <div class="image-circle">
                        <img *ngIf="chat.user.profilePicture"
                                [src]="chat.user.profilePicture"
                                (error)="chat.user.profilePicture = ''" />
                        <span
                            *ngIf="!chat.user.profilePicture">{{ chat.user.name | shortName }}</span>
                    </div>
                    <div class="name">
                        <h5>{{chat.user.name}}</h5>
                    </div>
                </div>

                <button class="btn btn-close" (click)='removeChat(i)'>
                    <img src="./assets/images/icons/close-white.svg" alt="">
                </button>
            </div>

            <div class="chat-area-container">
                <div class="chat-area scroll-area" [id]="'chat-' + i">
                    <div class="dataLoading" *ngIf='!chat.msgList.length && chat.loading'>
                        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                    </div>

                    <ng-container *ngIf="!chat.loading">
                        <div class="no-message" *ngIf="!chat.msgList.length">
                            <div>
                                <img src="./assets/images/icons/chat-empty.svg" alt="">
                                <p>{{ 'chat.No messages yet' | translate }}</p>
                            </div>
                        </div>

                        <ul *ngIf="chat.msgList.length">
                            <li *ngFor="let message of chat.msgList" [class.mine]='message.mine'>
                                <div>
                                    <p>{{ message.text }}</p>
                                    <p class="time">{{ message.time | date:'hh:mm aaa' }}</p>
                                </div>
                            </li>
                        </ul>
                    </ng-container>
                </div>
                <div class="send-form">
                    <div>
                        <input type="text" placeholder="{{ 'chat.Enter your message' | translate }}"
                            [(ngModel)]='chat.message'
                            [dir]="chat.textDir"
                            (keyup)="checkKeyboard($event, chat)"
                            (keydown.enter)='send(chat)'>
                        <button class="btn" (click)='send(chat)'>
                            <img src="./assets/images/icons/ic_send.svg" alt="">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
